export const translations = {
  ro: {
    nav: { shop: "MAGAZIN", about: "MANIFEST", cart: "COȘ" },
    hero: {
      line1: "MATERIE",
      line2: "PRIMĂ.",
      line3: "FORMĂ",
      line4: "BRUTĂ.",
      tag: "COLECȚIA 001 — BETON",
      cta: "INTRĂ ÎN COLECȚIE",
    },
    marquee: "LAINER — FĂCUT ÎN ROMÂNIA — MATERIE PRIMĂ — EDIȚIE LIMITATĂ — ",
    manifestoTitle: "MANIFEST",
    manifesto: [
      { n: "01", t: "FĂRĂ ZGOMOT", d: "Eliminăm tot ce nu servește forma. Fără logo-uri stridente, fără exces. Doar materialul și croiala." },
      { n: "02", t: "MATERIE ONESTĂ", d: "Bumbac greu, lână merinos, țesături tehnice. Fiecare piesă e construită să reziste, nu să impresioneze pe termen scurt." },
      { n: "03", t: "PRODUS AICI", d: "Tăiat și cusut în România, în serii mici. Controlăm fiecare cusătură pentru că fiecare piesă poartă numele nostru." },
    ],
    featuredTitle: "PIESE SELECTATE",
    shopTitle: "MAGAZIN",
    shopSub: "Colecția completă LAINER",
    product: {
      colors: "CULOARE",
      sizes: "MĂRIME",
      sizeGuide: "GHID MĂRIMI",
      inStock: "ÎN STOC",
      lowStock: "STOC LIMITAT",
      outOfStock: "STOC EPUIZAT",
      addToCart: "ADAUGĂ ÎN COȘ",
      selectSize: "SELECTEAZĂ MĂRIMEA",
      details: "DETALII PRODUS",
      delivery: "LIVRARE & RETUR",
      deliveryText: "Livrare 5–6 zile lucrătoare prin curier. Plata la livrare (ramburs). Retur gratuit în 30 de zile.",
      added: "Adăugat în coș",
      soldOut: "EPUIZAT",
      presale: "PRECOMANDĂ",
    },
    cart: {
      title: "COȘUL TĂU",
      empty: "Coșul este gol.",
      continue: "CONTINUĂ CUMPĂRĂTURILE",
      subtotal: "SUBTOTAL",
      shipping: "LIVRARE",
      free: "GRATUITĂ",
      total: "TOTAL",
      checkout: "FINALIZEAZĂ COMANDA",
      size: "Mărime",
      color: "Culoare",
      remove: "Elimină",
    },
    checkout: {
      title: "FINALIZARE COMANDĂ",
      contact: "CONTACT",
      shipping: "LIVRARE",
      name: "Nume complet",
      email: "Email",
      phone: "Telefon",
      address: "Adresă",
      city: "Oraș",
      county: "Județ",
      postal: "Cod poștal",
      notes: "Note comandă (opțional)",
      summary: "SUMAR COMANDĂ",
      place: "PLASEAZĂ COMANDA",
      placing: "SE PROCESEAZĂ...",
      empty: "Nu ai produse în coș.",
      noPayment: "Fără plată online — comanda se confirmă și se achită la livrare.",
    },
    confirm: {
      title: "COMANDĂ PRIMITĂ",
      thanks: "Mulțumim. Comanda ta a fost înregistrată.",
      order: "COMANDĂ",
      back: "ÎNAPOI LA MAGAZIN",
    },
    footer: {
      tagline: "MATERIE PRIMĂ. FORMĂ BRUTĂ.",
      rights: "TOATE DREPTURILE REZERVATE",
      newsletter: "ABONEAZĂ-TE",
      emailPlaceholder: "EMAIL",
    },
    sizeGuideModal: {
      title: "GHID DE MĂRIMI",
      desc: "Măsurători în centimetri. Piesele au croială oversized.",
      cols: ["MĂRIME", "PIEPT", "LUNGIME", "UMĂR"],
    },
  },
  en: {
    nav: { shop: "SHOP", about: "MANIFESTO", cart: "CART" },
    hero: {
      line1: "RAW",
      line2: "MATTER.",
      line3: "BRUTAL",
      line4: "FORM.",
      tag: "COLLECTION 001 — CONCRETE",
      cta: "ENTER THE COLLECTION",
    },
    marquee: "LAINER — MADE IN ROMANIA — RAW MATTER — LIMITED EDITION — ",
    manifestoTitle: "MANIFESTO",
    manifesto: [
      { n: "01", t: "NO NOISE", d: "We remove everything that doesn't serve the form. No loud logos, no excess. Only material and cut." },
      { n: "02", t: "HONEST MATTER", d: "Heavyweight cotton, merino wool, technical fabrics. Every piece is built to last, not to impress in the short term." },
      { n: "03", t: "MADE HERE", d: "Cut and sewn in Romania, in small runs. We control every stitch because every piece carries our name." },
    ],
    featuredTitle: "SELECTED PIECES",
    shopTitle: "SHOP",
    shopSub: "The full LAINER collection",
    product: {
      colors: "COLOR",
      sizes: "SIZE",
      sizeGuide: "SIZE GUIDE",
      inStock: "IN STOCK",
      lowStock: "LOW STOCK",
      outOfStock: "OUT OF STOCK",
      addToCart: "ADAUGĂ ÎN COȘ",
      selectSize: "SELECT A SIZE",
      details: "PRODUCT DETAILS",
      delivery: "DELIVERY & RETURNS",
      deliveryText: "Delivery in 5–6 working days by courier. Cash on delivery. Free returns within 30 days.",
      added: "Added to cart",
      soldOut: "SOLD OUT",
      presale: "PRE-ORDER",
    },
    cart: {
      title: "YOUR CART",
      empty: "Your cart is empty.",
      continue: "CONTINUE SHOPPING",
      subtotal: "SUBTOTAL",
      shipping: "SHIPPING",
      free: "FREE",
      total: "TOTAL",
      checkout: "CHECKOUT",
      size: "Size",
      color: "Color",
      remove: "Remove",
    },
    checkout: {
      title: "CHECKOUT",
      contact: "CONTACT",
      shipping: "SHIPPING",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      city: "City",
      county: "County",
      postal: "Postal code",
      notes: "Order notes (optional)",
      summary: "ORDER SUMMARY",
      place: "PLACE ORDER",
      placing: "PROCESSING...",
      empty: "You have no items in your cart.",
      noPayment: "No online payment — order is confirmed and paid on delivery.",
    },
    confirm: {
      title: "ORDER RECEIVED",
      thanks: "Thank you. Your order has been registered.",
      order: "ORDER",
      back: "BACK TO SHOP",
    },
    footer: {
      tagline: "RAW MATTER. BRUTAL FORM.",
      rights: "ALL RIGHTS RESERVED",
      newsletter: "SUBSCRIBE",
      emailPlaceholder: "EMAIL",
    },
    sizeGuideModal: {
      title: "SIZE GUIDE",
      desc: "Measurements in centimetres. Pieces have an oversized fit.",
      cols: ["SIZE", "CHEST", "LENGTH", "SHOULDER"],
    },
  },
};

export const SIZE_CHART = [
  ["S", "112", "70", "48"],
  ["M", "118", "72", "51"],
  ["L", "124", "74", "54"],
  ["XL", "130", "76", "57"],
  ["XXL", "136", "78", "60"],
];
